import * as yup from 'yup';
import { useFormHandler } from './useFormHandler';

export type TestFormValues = {
  subject: string;
  series: Array<{ _id: string; name: string }>;
  duration: number;
  name: string;
  position: number;
};

export const testValidationSchema = yup.object({
  subject: yup.string().required('La matière est obligatoire.'),
  series: yup
    .array()
    .of(
      yup.object().shape({
        _id: yup.string().required(),
        name: yup.string().required(),
      }),
    )
    .min(1, 'Veuillez sélectionner au moins une série.')
    .required('La série est obligatoire'),
  duration: yup
    .number()
    .required('La durée est obligatoire.')
    .positive('La durée doit être un nombre positif.')
    .integer('La durée doit être un nombre entier.')
    .typeError('Veuillez entrer une durée valide.'),
  name: yup.string().required('Le nom est obligatoire.'),
  position: yup
    .number()
    .required('La position est obligatoire.')
    .positive('La position doit être un nombre positif.')
    .integer('La position doit être un nombre entier.')
    .typeError('Veuillez entrer une position valide.'),
});

export const useTestForm = () => {
  const { register, handleSubmit, errors, setValue, reset, getValues } =
    useFormHandler<TestFormValues>(testValidationSchema);

  return { register, handleSubmit, errors, setValue, reset, getValues };
};

export type ExerciseFormValues = {
  name: string;
};

export const exerciseValidationSchema = yup.object({
  name: yup.string().required('Le nom est obligatoire.'),
});

export const useExerciseForm = () => {
  const { register, handleSubmit, errors, setValue, reset, getValues } =
    useFormHandler<ExerciseFormValues>(exerciseValidationSchema);

  return { register, handleSubmit, errors, setValue, reset, getValues };
};
